import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { JobServiceListItem } from 'src/app/shared/models/job-service-list-item.model';
import { IWorkerService } from 'src/app/shared/models/worker-service.model';
import { basicSearchFilters, flexServices } from '../worker-service-data';

@Component({
  selector: 'app-worker-services',
  templateUrl: './worker-services.component.html',
  styleUrls: ['./worker-services.component.scss'],
})
export class WorkerServicesComponent implements OnInit, OnChanges {
  // Services provide by the support worker
  @Input() services: Array<JobServiceListItem>;

  // Is flex service or not
  @Input() isFlex = false;

  // Service selected in worker service list
  @Input() selectedServices: Array<string> = [];

  // Event Emitter for the Worker Service update.
  @Output() selectedServicesChange = new EventEmitter<Array<string>>();

  ngOnInit() {
    if (!this.services) {
      this.services = this.isFlex ? flexServices() : basicSearchFilters();
    }
    this.initializeServices();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedServices) {
      this.initializeServices();
    }
  }

  /**
   * Initialize the array list and the changes are reflected as well.
   */
  initializeServices() {
    this.services?.forEach((workerService) => {
      const pos = this.selectedServices.indexOf(workerService.id);
      if (pos !== -1) {
        workerService.selected = true;
      } else {
        workerService.selected = false;
      }
    });
  }

  /**
   * Emit output event to update the selected service
   *
   * @param service - selected service.
   */
  updateServices(service: IWorkerService) {
    const pos = this.selectedServices.indexOf(service.id);
    if (pos === -1 && service.selected) {
      this.selectedServices.push(service.id);
    } else if (!service.selected) {
      this.selectedServices.splice(pos, 1);
    }
    this.selectedServicesChange.emit(this.selectedServices);
  }
}
